import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config.ts';
import { RequestHeaders } from '@/@types/auth.types';

type Props = {
    token: string;
    tenant: string;
};

export const useRegistrationConfirmApi = ({ token, tenant }: Props) => {
    const axiosInstance = useAxiosAuth();
    axiosInstance.defaults.headers[RequestHeaders.TenantId] = tenant;

    const {
        data: confirmRegistrationStatus,
        isLoading: isDoConfirmRegistrationStatusLoading,
        isError: isErrorConfirmRegistrationStatus,
    } = useQuery({
        queryKey: [ApiConfig.queries.auth.queryKeys.registrationConfirm, token],
        queryFn: async (): Promise<number> => {
            const url = ApiConfig.queries.auth.endpoints.registrationConfirm;
            const response = await axiosInstance.post(url, { token });

            return response.status;
        },
    });

    return {
        confirmRegistrationStatus,
        isDoConfirmRegistrationStatusLoading,
        isErrorConfirmRegistrationStatus,
    };
};
